/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataRestore.tpl.html';

angular
  .module('chatterMain.metadataRestore', [])
  .constant('METADATA_RESTORE_STATE', {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED'
  })
  /**
   * Controller for the chatter.metadatarestore template.
   */
  .controller(
    'ChatterMetadataRestoreCtrl',
    function (
      $scope,
      httpBatch,
      $filter,
      batchUtils,
      progressFactory,
      metadataRestoreBatch,
      CHATTER_SIZES,
      METADATA_RESTORE_STATE
    ) {
      var origMetadataRestoreState = metadataRestoreBatch.state;

      if (origMetadataRestoreState === METADATA_RESTORE_STATE.FINISHED) {
        progressFactory.disableProgress();
      }

      /**
       * Utility function to set the scope vars for the batch metadataRestore
       */
      function setMetadataRestoreBatchData(batch) {
        var MetadataRestoreDate = moment(batch.date).format('MMM D[,] YYYY h:mm A'),
          objectTotal = batch.metadataRestoreData.totalObjects,
          objectCompleted = batch.metadataRestoreData.objectsComplete,
          stateText =
            batch.state === METADATA_RESTORE_STATE.FINISHED
              ? $filter('i18n')('COMPLETED_LOWERCASE')
              : $filter('i18n')('STARTED');

        if (objectCompleted === 1 && objectTotal === 1) {
          $scope.metadataRestoreText = $filter('i18n')('BATCH_METADATA_RESTORE_DETAIL_DATE_SINGLE', [
            $filter('i18n')('RESTORE'),
            stateText,
            MetadataRestoreDate
          ]);
        } else {
          $scope.metadataRestoreText = $filter('i18n')('BATCH_METADATA_RESTORE_DETAIL_DATE', [
            $filter('i18n')('RESTORE'),
            stateText,
            MetadataRestoreDate,
            objectCompleted,
            objectTotal
          ]);
        }

        $scope.metadataRestoreBatch = batch;
        $scope.batchUtils = batchUtils;
        $scope.METADATA_RESTORE_STATE = METADATA_RESTORE_STATE;
      }

      // Setup the scope values for the initial load of the controller
      setMetadataRestoreBatchData(metadataRestoreBatch);

      // Watches to resize the canvas app based on the current state of the backup.
      $scope.$watch('metadataRestoreInProgress ', function () {
        if (!$scope.metadataRestoreInProgress || metadataRestoreBatch.state === METADATA_RESTORE_STATE.FINISHED) {
          // if the original metadataRestoreStatus was not Finished then load the batch.
          if (origMetadataRestoreState !== METADATA_RESTORE_STATE.FINISHED) {
            httpBatch.getBatch($scope.stateParams.batchId).then(function (batch) {
              setMetadataRestoreBatchData(batch);
            });
          }
          if (!progressFactory.disabled) {
            progressFactory.disableProgress();
          }
        }
      });

      /**
       * Handler to show metadataRestore details page in app.
       */
      $scope.showMetadataRestoreInApp = function () {
        // Use the chatter gotoApp function.
        $scope.gotoApp('?batchId=' + $scope.stateParams.batchId + '&page=metadataRestoreDetails');
      };
    }
  );
